import { render, staticRenderFns } from "./ImportResults.vue?vue&type=template&id=b40a6158&"
import script from "./ImportResults.vue?vue&type=script&lang=js&"
export * from "./ImportResults.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports